module.exports = __webpack_public_path__ + "img/image_news_Tiny_Tan_collabo02.80eefbb7.jpg";